import React, { useState } from 'react';
import gameService from '../services/gameService';
import { gatewayDocumentTypes, gatewayDocumentKey, queueGatewayDocuments } from '../utils/gatewayDocuments';

const GatewayDocuments = ({ documents = [], onChange, canEdit, saveHint = 'Uploads when you save the merchant.' }) => {
  const [error, setError] = useState('');
  const chooseFiles = event => {
    try {
      onChange(queueGatewayDocuments(documents, Array.from(event.target.files || [])));
      setError('');
    } catch (err) { setError(err.message); }
    event.target.value = '';
  };
  return <section style={{ display: 'grid', gap: '0.75rem' }} aria-label="Payment gateway documents">
    <span style={{ fontSize: '0.875rem', fontWeight: 600 }}>Upload Documents</span>
    {canEdit && <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center' }}>
      <label className="btn btn-secondary" style={{ cursor: 'pointer' }}>Choose Files
        <input type="file" aria-label="Upload payment gateway documents" accept={gatewayDocumentTypes} multiple onChange={chooseFiles} style={{ display: 'none' }} />
      </label>
      <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>PDF, Word, Excel, JPG, PNG · max 10MB each, 20 files per gateway. {saveHint}</span>
    </div>}
    {error && <p role="alert" style={{ color: 'var(--error)', margin: 0 }}>{error}</p>}
    <div style={{ display: 'grid', gap: '0.75rem', padding: '0.75rem', background: 'var(--bg-soft)', border: '1px solid var(--border-light)', borderRadius: 'var(--radius-md)' }}>
      {!documents.length && <span style={{ fontSize: '0.8125rem', color: 'var(--text-muted)' }}>No documents added</span>}
      {documents.map((document, index) => <div key={gatewayDocumentKey(document)} style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 240px', minWidth: 0 }}>
          <div style={{ overflowWrap: 'anywhere', fontSize: '0.8125rem', fontWeight: 600 }}>{document.original_name}</div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', margin: '0.25rem 0' }}>{Math.ceil((document.size || 0) / 1024)} KB · {document.file ? 'Pending upload' : 'Uploaded'}</div>
          <input className="input" aria-label={`Document ${index + 1} label`} placeholder="Document label (e.g. Agreement, API Spec)" value={document.label || ''} disabled={!canEdit}
            onChange={event => onChange(documents.map((item, i) => i === index ? { ...item, label: event.target.value } : item))} />
        </div>
        {document.file_path && <a className="btn" href={gameService.getMasterProviderDocumentUrl(document)} target="_blank" rel="noopener noreferrer">View</a>}
        {canEdit && <button type="button" className="btn" style={{ color: 'var(--error)' }} onClick={() => onChange(documents.filter((_, i) => i !== index))}>Delete</button>}
      </div>)}
    </div>
  </section>;
};

export default GatewayDocuments;
